/* VORTEX — MATCHDAY: comportamento compartilhado da camada visual.
   Tudo aqui é progressivo: sem o JS a página continua navegável. */
(function () {
  'use strict';

  /* ---------- 1. Carrosséis (setas + barra de progresso) ---------- */
  function ligaCarrossel(raiz) {
    var trilho = raiz.querySelector('[data-mdx-trilho]');
    if (!trilho) return;
    var prev = raiz.querySelector('[data-mdx-prev]');
    var next = raiz.querySelector('[data-mdx-next]');
    var prog = raiz.querySelector('[data-mdx-prog]');

    function pinta() {
      var max = trilho.scrollWidth - trilho.clientWidth;
      var p = max > 0 ? trilho.scrollLeft / max : 0;
      if (prog) prog.style.width = Math.max(14, p * 100) + '%';
      if (prev) prev.disabled = trilho.scrollLeft < 10;
      if (next) next.disabled = trilho.scrollLeft > max - 10;
    }
    function anda(dir) {
      trilho.scrollBy({ left: dir * trilho.clientWidth * 0.9, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { anda(-1); });
    if (next) next.addEventListener('click', function () { anda(1); });
    trilho.addEventListener('scroll', function () { requestAnimationFrame(pinta); }, { passive: true });
    window.addEventListener('resize', pinta);
    pinta();
  }
  document.querySelectorAll('[data-mdx-car]').forEach(ligaCarrossel);

  /* ---------- 2. Drawer do menu ---------- */
  var drawer = document.querySelector('[data-mdx-drawer]');
  var scrim = document.querySelector('[data-mdx-scrim]');
  function drawerAbre(sim) {
    if (!drawer) return;
    drawer.classList.toggle('is-aberto', sim);
    if (scrim) scrim.classList.toggle('is-aberto', sim);
    document.documentElement.style.overflow = sim ? 'hidden' : '';
  }
  document.querySelectorAll('[data-mdx-drawer-abre]').forEach(function (b) {
    b.addEventListener('click', function () { drawerAbre(true); });
  });
  document.querySelectorAll('[data-mdx-drawer-fecha]').forEach(function (b) {
    b.addEventListener('click', function () { drawerAbre(false); });
  });
  if (scrim) scrim.addEventListener('click', function () { drawerAbre(false); });

  /* ---------- 3. Modais (size guide) ---------- */
  document.querySelectorAll('[data-mdx-modal-abre]').forEach(function (b) {
    b.addEventListener('click', function () {
      var alvo = document.getElementById(b.getAttribute('data-mdx-modal-abre'));
      if (alvo) alvo.classList.add('is-aberto');
    });
  });
  document.querySelectorAll('[data-mdx-modal-fecha]').forEach(function (b) {
    b.addEventListener('click', function () {
      var m = b.closest('.mdx-modal');
      if (m) m.classList.remove('is-aberto');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.mdx-modal.is-aberto').forEach(function (m) { m.classList.remove('is-aberto'); });
  });

  /* ---------- 4. Bandeira FREE na pílula "Customize" ---------- */
  document.querySelectorAll('[data-opt-custom] [data-opt-value]').forEach(function (b) {
    var v = (b.getAttribute('data-value') || b.textContent || '');
    if (/customize/i.test(v) && !/don|no/i.test(v) && !b.querySelector('.mdx-free-flag')) {
      var f = document.createElement('span');
      f.className = 'mdx-free-flag';
      f.textContent = 'FREE';
      b.appendChild(f);
    }
  });

  /* ---------- 5. Escassez HONESTA (estoque real da variante) ----------
     Lê o JSON de variantes que o Liquid imprime em [data-mdx-inv]; só mostra
     quando a Shopify rastreia o estoque e ele está baixo (1..9). Nada de
     número inventado — regra do projeto. */
  var invEl = document.querySelector('[data-mdx-inv]');
  var caixaEstoque = document.querySelector('[data-mdx-estoque]');
  if (invEl && caixaEstoque) {
    var mapa = {};
    try { mapa = JSON.parse(invEl.textContent) || {}; } catch (e) {}
    function pintaEstoque() {
      var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var qtd = idInput ? mapa[idInput.value] : null;
      var mostra = typeof qtd === 'number' && qtd > 0 && qtd < 10;
      caixaEstoque.classList.toggle('is-on', !!mostra);
      if (mostra) {
        var n = caixaEstoque.querySelector('[data-mdx-estoque-n]');
        var b = caixaEstoque.querySelector('.mdx-estoque__barra i');
        if (n) n.textContent = qtd;
        if (b) b.style.width = Math.max(8, qtd * 10) + '%';
      }
    }
    pintaEstoque();
    document.addEventListener('change', pintaEstoque);
    document.addEventListener('click', function () { setTimeout(pintaEstoque, 60); });
  }

  /* ---------- 6. Barra sticky de compra (mobile) ---------- */
  var barra = document.querySelector('[data-mdx-barra]');
  var sentinela = document.querySelector('[data-mdx-sentinela]');
  if (barra && sentinela && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { barra.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(sentinela);
    var btn = barra.querySelector('button');
    if (btn) btn.addEventListener('click', function () {
      var atc = document.querySelector('button[data-atc]');
      if (atc) atc.click();
    });
  }

  /* ---------- 7. Abas de fonte (League font / Club font) ----------
     O preview (foto das costas + nome + número) já usa classes vs-kf-<código>
     cujas @font-face vivem no CSS do tema. Alternar fonte = trocar a classe
     no container do preview — nada de carregar arquivo na mão.
     cfg: {"clube":"barcelona","liga":"pl"} (só as que o produto tem). */
  var fontesRaiz = document.querySelector('[data-mdx-fontes]');
  if (fontesRaiz) {
    var cfg = {};
    try { cfg = JSON.parse(fontesRaiz.getAttribute('data-mdx-fontes-cfg') || '{}'); } catch (e) {}
    var preview = document.querySelector('[data-custom-preview]');
    var hidden = document.querySelector('[data-mdx-nameset]');
    function aplica(tipo) {
      var kf = cfg[tipo];
      if (!kf || !preview) return;
      (preview.className.match(/vs-kf-[a-z]+/g) || []).forEach(function (c) { preview.classList.remove(c); });
      preview.classList.add('vs-kf-' + kf);
      if (hidden) hidden.value = tipo === 'liga' ? 'League' : 'Club';
      fontesRaiz.querySelectorAll('button').forEach(function (b) {
        var ativo = b.getAttribute('data-mdx-fonte') === tipo;
        b.classList.toggle('is-ativa', ativo);
        b.setAttribute('aria-pressed', ativo ? 'true' : 'false');
      });
    }
    fontesRaiz.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { aplica(b.getAttribute('data-mdx-fonte')); });
    });
    aplica(cfg.clube ? 'clube' : 'liga'); /* clube é o padrão, como lá */
  }

  /* ---------- 8. Palco do preview (MATCHDAY) ----------
     O Liquid renderiza o preview depois das abas; a loja modelo mostra as
     COSTAS DA CAMISA primeiro, já visíveis antes de digitar. Move pro palco
     e mantém visível enquanto o painel estiver aberto (o vstore.js esconde
     quando os campos estão vazios — aqui isso é revertido). */
  /* parcelas do Shop Pay: renderizadas dentro do form, exibidas sob o preço */
  var ptSrc = document.querySelector('[data-mdx-payterms-src]');
  var ptDst = document.querySelector('[data-mdx-payterms]');
  if (ptSrc && ptDst) { while (ptSrc.firstChild) ptDst.appendChild(ptSrc.firstChild); ptSrc.remove(); ptDst.hidden = false; }

  /* slider de reviews: o track (flex) mede o MAIOR card; aqui a altura
     acompanha o card visível, sem vão embaixo */
  var trk = document.querySelector('.vsr__slider-track');
  if (trk) {
    var ajustaTrk = function () {
      var cards = trk.querySelectorAll('.vsr__card');
      if (!cards.length) return;
      var m = (trk.style.transform || '').match(/-?\d+(\.\d+)?/);
      var i = 0;
      if (m) { var px = Math.abs(parseFloat(m[0])); var w = cards[0].getBoundingClientRect().width || 1; i = /%/.test(trk.style.transform) ? Math.round(px / 100) : Math.round(px / w); }
      var alvo = cards[Math.min(i, cards.length - 1)];
      trk.style.height = alvo.getBoundingClientRect().height + 'px';
      trk.style.alignItems = 'flex-start';
    };
    ajustaTrk();
    new MutationObserver(ajustaTrk).observe(trk, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', ajustaTrk);
    setTimeout(ajustaTrk, 800);
  }

  var palco = document.querySelector('[data-mdx-palco]');
  var prev = document.querySelector('[data-mdx-preview]');
  if (palco && prev) {
    palco.appendChild(prev);
    var mostra = function () { prev.hidden = false; };
    mostra();
    new MutationObserver(mostra).observe(prev, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* ---------- 9. What's my size? dinâmico ----------
     - tabelas viram ABAS (a do produto abre primeiro);
     - quando a calculadora sugere um tamanho, a coluna dele acende na tabela. */
  var painel = document.querySelector('[data-sizechart]');
  if (painel) {
    var grupos = [].slice.call(painel.querySelectorAll('.vs-sizegrp'));
    var tabelas = grupos.filter(function (g) { return g.querySelector('table'); });
    if (tabelas.length > 1) {
      var abas = document.createElement('div'); abas.className = 'mdx-size-tabs';
      var tabProduto = (painel.querySelector('[data-calc]') || {}).dataset ? painel.querySelector('[data-calc]').dataset.tabla : 'men';
      var mapa = { men: /men's jerseys/i, player: /player|authentic/i, women: /women/i, kids: /kids/i, pet: /pet/i };
      var ativo = tabelas.find(function (g) { return (mapa[tabProduto] || mapa.men).test(g.querySelector('summary').textContent); }) || tabelas[0];
      tabelas.forEach(function (g) {
        var b = document.createElement('button'); b.type = 'button';
        b.textContent = g.querySelector('summary').textContent.replace(/jerseys?/i, '').replace(/·.*$/, '').trim();
        b.addEventListener('click', function () { tabelas.forEach(function (x) { x.open = x === g; x.classList.toggle('is-on', x === g); }); abas.querySelectorAll('button').forEach(function (y) { y.classList.toggle('is-on', y === b); }); });
        if (g === ativo) b.classList.add('is-on');
        abas.appendChild(b);
      });
      tabelas.forEach(function (g) { g.open = g === ativo; g.classList.toggle('is-on', g === ativo); g.classList.add('mdx-size-tab'); });
      tabelas[0].parentNode.insertBefore(abas, tabelas[0]);
    }
    var out = painel.querySelector('[data-calc-out]');
    if (out) new MutationObserver(function () {
      var m = (out.textContent || '').match(/Size\s+(\d?X{0,3}[SML]|\d{2,3})/i); if (!m) return;
      var alvo = m[1].toUpperCase();
      painel.querySelectorAll('.vs-sizetable').forEach(function (t) {
        var ths = [].slice.call(t.querySelectorAll('thead th'));
        var idx = ths.findIndex(function (th) { return th.textContent.trim().toUpperCase() === alvo; });
        t.querySelectorAll('.is-sugerido').forEach(function (c) { c.classList.remove('is-sugerido'); });
        if (idx < 0) return;
        t.querySelectorAll('tr').forEach(function (tr) { var c = tr.children[idx]; if (c) c.classList.add('is-sugerido'); });
      });
    }).observe(out, { childList: true, subtree: true, characterData: true });
  }
})();
